/* Traduction des erreurs Supabase en message lisible.

   Sans ça, une écriture rejetée passait inaperçue : le code affichait
   un message de succès et l'utilisateur découvrait le problème plus
   tard, en voyant la donnée inchangée. */

export function messageErreur(error) {
  const m = error?.message || 'erreur inconnue'

  // Colonne absente : une migration SQL n'a pas été exécutée
  if (/column .* does not exist|could not find the .* column|schema cache/i.test(m)) {
    return `migration SQL en attente — la base ne connaît pas encore une des colonnes (${m})`
  }
  // Contrainte de valeur (ex. statut hors liste autorisée)
  if (/violates check constraint/i.test(m)) {
    return `valeur refusée par la base (${m})`
  }
  // Droits insuffisants
  if (/row-level security|permission denied/i.test(m)) {
    return `écriture refusée : droits insuffisants (${m})`
  }
  return m
}

/* Enveloppe une écriture Supabase : renvoie true si elle a réellement
   abouti, sinon affiche l'erreur et renvoie false. */
export async function ecrire(promesse, toast, quoi = 'enregistrement') {
  const { error } = await promesse
  if (error) {
    console.error(quoi, error)
    toast(`Échec de l'${quoi} : ${messageErreur(error)}`, 'error')
    return false
  }
  return true
}

/* Pendant de `ecrire` pour les lectures.

   Une requête refusée renvoie `data: null` sans lever d'exception :
   sans ce garde-fou, une liste vide s'affiche exactement comme un
   échec silencieux, et on croit ses données perdues alors qu'elles
   sont intactes en base. */
export async function lire(promesse, toast, quoi = 'chargement') {
  const { data, error } = await promesse
  if (error) {
    console.error(quoi, error)
    toast(`Échec du ${quoi} : ${messageErreur(error)}`, 'error')
    return null
  }
  return data
}
